import { makeRequest } from './request.service'
import { buildDashboardDateRangeQuery } from 'utils/dateRangeFilters'

export const getLeamSummaryData = async (farmId, dateRange = null) => {
  try {
    const query = dateRange ? `?${buildDashboardDateRangeQuery(dateRange)}` : ''
    const response = await makeRequest({
      method: 'GET',
      url: `/dashboard/${farmId}/leam-summary${query}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('secret')}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching LEAM summary data:', error)
    throw error
  }
}
